
import {
  CareerSiteBrandConfigurationResponse,
  CareerSiteService,
} from 'api-clients/monolith';
import { useEffect, useState } from 'react';

export function useBrandConfig(
  accountSlug: string,
  brandId: string,
  locale?: string,
) {
  const [data, setData] = useState<CareerSiteBrandConfigurationResponse>();
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    const fetchData = () => {
      setIsFetching(true);
      CareerSiteService.getInternalApiCareerSiteBrandsConfiguration({
        account_slug: accountSlug,
        brand_id: brandId,
        locale,
      })
        .then((result: CareerSiteBrandConfigurationResponse) => {
          setData(result);
        })
        .catch(() => {
          // fetch error — not re-thrown
        })
        .finally(() => {
          setIsFetching(false);
        });
    };
    void fetchData();
  }, [accountSlug, brandId, locale]);

  return { data, isFetching, setData };
}
